/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./AdminTopbar";
import AdminPersonas from "./AdminPersonas";
import AdminDepartamentos from "./AdminDepartamentos";
import AdminEdificios from "./AdminEdificios";
import useVersionMovil from "../../hooks/useMobileVersion";
import { Offcanvas} from "react-bootstrap";
import "../../styles/AdminLayout.css";
/**
 * Componente principal del panel de administrador.
 * Este layout define la estructura general del área de administración,
 * compuesta por un menú lateral, una barra superior y un área central
 * donde se renderizan las distintas secciones de gestión.
 */
const AdminLayout = () => {

  // Estado que almacena la sección activa del panel de administración
  // Su valor determina qué componente se renderiza en el área principal
  const [activeSection, setActiveSection] = useState("personas");
  const isMobile = useVersionMovil();
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    if (!isMobile) setShowMenu(false);
  }, [isMobile]);

  return (
    <>
       {/* ===================== MENÚ LATERAL (Sidebar) ===================== */}
      {!isMobile && (
      <AdminSidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />)}

      {/* ===================== BARRA SUPERIOR (Topbar) ===================== */}
      <AdminTopbar onMenuClick={() => setShowMenu(true)}/>

       {/* 🔹 Offcanvas SOLO en móvil */}
      {isMobile && (
        <Offcanvas
          show={showMenu}
          onHide={() => setShowMenu(false)}
          placement="start"
          className="bg-dark text-white"
          style={{width: "240px"}}
        >
          <Offcanvas.Body className="p-0 d-flex flex-column">
            <AdminSidebar
              activeSection={activeSection}
              setActiveSection={(section) => {
                setActiveSection(section);
                setShowMenu(false);
              }}
            />
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {/* ===================== CONTENIDO PRINCIPAL ===================== */}
      {/* Zona central donde se renderiza dinámicamente la sección seleccionada */}
      <main className="admin-main-content">
        
        {/* Gestión de personas */}
        {activeSection === "personas" && <AdminPersonas />}
        
        {/* Gestión de departamentos */}
        {activeSection === "departamentos" && <AdminDepartamentos />}
        
        {/* Gestión de edificios */}
        {activeSection === "edificios" && <AdminEdificios />}
      </main>
    </>
  );
};

export default AdminLayout;